module.exports = __webpack_public_path__ + "img/partner14.dcbb47b7.png";